import { createMuiTheme } from '@material-ui/core';
import { createTheme } from '@mui/material';
import { muiV4Compat } from './muiV4Compat';

// v4 theme — feeds the @material-ui/core MuiThemeProvider that still wraps
// not-yet-migrated components. Needs its own copy of `overrides`/`width`/
// `textDecoration` because @mui/material's createTheme() output (below) is a
// different shape v4's JSS engine doesn't read (e.g. no `overrides` support).
export const vooptyThemeV4 = createMuiTheme({
  typography: {
    fontSize: 14,
  },
  palette: {
    primary: {
      light: '#fbfbfb',
      main: '#FDAA2D',
      dark: '#1e2024',
      contrastText: '#fff',
    },
    secondary: {
      light: '#595959',
      main: '#1e2024',
      dark: '#1e2024',
      attention: '#ba000d',
      contrastText: '#fff',
    },
  },
  zIndex: { drawer: 1040 },
  width: { sectionWidth: 1360 },
  textDecoration: { Link: 'none', a: 'none' },
  overrides: {
    MuiLink: {
      root: {
        color: '#337ab7',
      },
    },
    MUIDataTable: {
      responsiveScroll: {
        maxHeight: undefined,
      },
    },
    MuiDivider: {
      light: {
        backgroundColor: '#fff',
      },
    },
    MuiTableCell: {
      root: {
        paddingLeft: '4px',
        paddingRight: '4px',
      },
    },
    MUIDataTableSelectCell: {
      root: {
        '@media (max-width: 959.95px)': {
          display: 'table-cell',
        },
      },
    },
  },
});

const _compat = muiV4Compat(vooptyThemeV4);
const _base = createTheme({ breakpoints: _compat.breakpoints });
const _gutters = () => ({
  paddingLeft: _base.spacing(2),
  paddingRight: _base.spacing(2),
  [_base.breakpoints.up('sm')]: {
    paddingLeft: _base.spacing(3),
    paddingRight: _base.spacing(3),
  },
});

export const vooptyTheme = createTheme({
  mixins: { gutters: _gutters },
  breakpoints: _compat.breakpoints,
  typography: {
    fontSize: 14,
  },
  palette: {
    ..._compat.palette,
    primary: {
      light: '#fbfbfb',
      main: '#FDAA2D',
      dark: '#1e2024',
      contrastText: '#fff',
    },
    secondary: {
      light: '#595959',
      main: '#1e2024',
      dark: '#1e2024',
      attention: '#ba000d',
      contrastText: '#fff',
    },
  },
  zIndex: { drawer: 1040 },
  width: { sectionWidth: 1360 },
  textDecoration: { Link: 'none', a: 'none' },
  // The new MUI ignores v4's `overrides` key - per-component styles go under `components`. The
  // mui-datatables overrides stay in the V4 theme only: that library renders v4 components.
  components: {
    ..._compat.components,
    MuiLink: {
      // Set as the default colour prop, not a style override: v5 applies the Link colour through
      // `sx`, which outranks theme styleOverrides.
      defaultProps: { ..._compat.components.MuiLink.defaultProps, color: '#337ab7' },
    },
    MuiDivider: {
      styleOverrides: {
        // v5 draws the divider with a border, v4 drew it with a background
        light: {
          borderColor: '#fff',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          paddingLeft: '4px',
          paddingRight: '4px',
        },
      },
    },
  },
});
